import _ from 'underscore';
import React from 'react';

import InstituteCard from 'components/cards/InstituteCard';
import SlideSection from 'components/SlideSection';

import CommonPropTypes from 'utils/propTypes/common';

const PopularInstitutes = ({ data }) => (
	<SlideSection
		title="Популярные площадки"
		moreControl={{
			title: 'Все площадки',
			url: '/streaming-platforms/[[...pathParams]]',
			as: '/streaming-platforms'
		}}
	>
		{_(data).map((item) => (
			<InstituteCard data={item} key={item._id} />
		))}
	</SlideSection>
);

PopularInstitutes.propTypes = {
	data: CommonPropTypes.entities.isRequired
};

export default PopularInstitutes;
